import React, { useEffect, useState } from "react";
import NetWorthDonut from "./NetWorthDonut";
import PieChart from "./PieChart";
import AssetDonutChart from "./AssetDonutChart";
import axios from "axios";
import ImageLoading from "../../components/ImageLoading";
import NoDataFound from "../../components/NoDataFound";
import { node } from "prop-types";

function Analytics({ id }) {
  const [chartFilter, setChartFilter] = useState("mutual_funds");
  const [filterList, setFilterList] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [tableList, setTableList] = useState([]);
  const [assetData, setAssetData] = useState({});
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const assignChartData = (filterName, data) => {
    // if (data?[filterName].length < 1) return [];
    if (data[filterName]?.length > 0) {
      return data[filterName]?.map((item) => {
        let repository = "---";
        if (item.repository === "ZERODHA BROKING LIMITED")
          repository = "Zerodha";
        else if (item.repository === "NEXTBILLION TECHNOLOGY PRIVATE LIMITED")
          repository = "Groww";
        else repository = item.repository;
        return {
          group: repository !== null ? repository : "---",
          value: item.total_value,
        };
      });
    }
    return [];
  };
  const checkForNoData = (data) => {
    let state = false;
    Object.keys(data).map((key) => {
      if (data[key].length > 0) {
        state = true;
      }
    });
    return state;
  };
  const selectFilterValue = (assetData) => {
    let filterValue = null;
    Object.keys(assetData).forEach((key) => {
      if (assetData[key].length > 0 && filterValue === null) {
        filterValue = key;
      }
    });
    return filterValue;
  };

  function formatToIndianRupees(num) {
    // Convert the number to a string
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }
  const formatRepository = (repository) => {
    if (repository === "ZERODHA BROKING LIMITED") return "Zerodha";
    if (repository === "NEXTBILLION TECHNOLOGY PRIVATE LIMITED") return "Groww";
    return repository;
  };
  const fetchSpectrum = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/asset_spectrum_analysis`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.data.asset_spectrum) {
        let state = checkForNoData(res.data.asset_spectrum);
        if (!state) setNoData(true);

        assignFilters(res.data.asset_spectrum);

        const filter = selectFilterValue(res.data.asset_spectrum);
        setAssetData(res.data.asset_spectrum);
        setChartFilter(filter);
        setGraphData(assignChartData(filter, res.data.asset_spectrum));
      } else {
        setAssetData({});
        setNoData(true);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNoData(true);
    }
  };
  function formatString(input) {
    let formattedString = input.replace(/_/g, " ");
    let words = formattedString.split(" ");
    words = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    formattedString = words.join(" ");
    return formattedString;
  }
  const assignFilters = (data) => {
    Object.keys(data).forEach((key) => {
      if (data[key]?.length > 0) {
        setFilterList((prev) => [
          ...prev,
          { name: formatString(key), value: key },
        ]);
      }
    });
  };
  useEffect(() => {
    setFilterList([]);
    fetchSpectrum();
  }, []);
  useEffect(() => {
    setGraphData(assignChartData(chartFilter, assetData));
  }, [chartFilter]);
  return (
    <div className=" mt-4 w-full overflow-auto h-[calc(100vh-190px)]">
      <div className="flex justify-between">
        <div className="h-[355px] bg-white rounded-lg w-[49.4%]">
          <NetWorthDonut id={id} />
        </div>
        <div className="h-[355px] bg-white rounded-lg w-[49.4%]">
          <PieChart id={id} />
        </div>
      </div>
      <div className="w-full bg-white pb-4 mt-4 rounded-lg flex flex-col ">
        {loading && (
          <div className="w-full h-[calc(100vh-500px)] flex items-center justify-center ">
            <ImageLoading />
          </div>
        )}
        {noData && (
          <div className="w-full h-[calc(100vh-500px)] flex items-center justify-center ">
            <NoDataFound />
          </div>
        )}

        {!loading && !noData && (
          <>
            {" "}
            <div className="rounded-[23px] bg-[#f8f8f8] text-sm font-semibold p-1  inline-block mr-auto ml-auto mt-6  flex-col">
              {filterList?.map((item, index) => (
                <button
                  index={index}
                  className={`${
                    chartFilter === item.value ? "bg-[#92e86c]" : ""
                  } w-[115px] py-[7px] rounded-[19px]`}
                  onClick={() => {
                    setChartFilter(item.value);
                    console.log(item.value + "Button");
                  }}
                >
                  {item.name}
                </button>
              ))}
            </div>
            <AssetDonutChart graphData={graphData} />
            <div className="w-[900px] border mr-auto ml-auto mt-12 p-6 border-[#e0e0e0] rounded-lg">
              <div className="w-full flex justify-between text-sm font-semibold">
                <p className="w-[30%]">Repository</p>
                <p className="w-[30%] text-center">Last fetched date</p>
                <p className="w-[30%] text-right">Last fetched valuation</p>
              </div>
              {assetData[chartFilter]?.map((item) => (
                <div className="w-full flex justify-between text-xs font-medium mt-[22px] h-[22px] items-center">
                  <p className="w-[30%] flex items-center">
                    {item.url !== null &&
                      chartFilter !== "vehicle" &&
                      chartFilter !== "real_estates" && (
                        <span className=" mr-2">
                          <img src={item.url} alt="" width={23} height={20} />
                        </span>
                      )}
                    <span>{formatRepository(item.repository) || "---"}</span>
                  </p>
                  <p className="w-[30%] text-center">
                    {item.last_fetched_date || "---"}
                  </p>
                  <p className="w-[30%] text-right">
                    {formatToIndianRupees(item.total_value) || "---"}
                  </p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Analytics;
